import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import HelpGuideModal from "./HelpGuideModal";
import { getHelpGuideData } from "./helpGuideData";
import { useTranslation } from "../../i18n/LanguageContext";

/**
 * HelpGuideButton — Self-contained "How?" trigger + modal.
 *
 * Drop this into any feature page header to give users a
 * step-by-step micro-tutorial for that feature.
 *
 * @param {number}   guideId        - The helpGuideData key (1–15)
 * @param {function} [setHeroContent] - Optional Hero-level navigation callback
 *                                      used by the modal's CTA to navigate
 *                                      to a different feature page.
 */
function HelpGuideButton({ guideId, setHeroContent }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const guide = getHelpGuideData(t)[guideId];
  if (!guide) return null;

  const handleOpen = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleNavigate = (overrideAction) => {
    setIsOpen(false);
    if (setHeroContent && overrideAction) {
      setHeroContent(overrideAction);
    }
  };

  return (
    <>
      <button
        className="helpguide-trigger-btn"
        onClick={handleOpen}
        aria-label={t("helpGuide.button.showMeHow")}
        title={t("helpGuide.button.showMeHow")}
      >
        <FontAwesomeIcon icon={faCircleQuestion} />
        <span className="helpguide-trigger-label">
          {t("helpGuide.button.how")}
        </span>
      </button>

      {isOpen && (
        <HelpGuideModal
          guide={guide}
          onClose={() => setIsOpen(false)}
          onNavigate={handleNavigate}
          actionLabel={setHeroContent ? guide.actionLabel : guide.actionLabel}
        />
      )}
    </>
  );
}

export default HelpGuideButton;
